import script from "./ComoFunciona.vue?vue&type=script&setup=true&lang=js"
export * from "./ComoFunciona.vue?vue&type=script&setup=true&lang=js"

import "./ComoFunciona.vue?vue&type=style&index=0&id=3849dc3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3849dc3e"]])

export default __exports__